module.exports = __webpack_public_path__ + "img/20200511154915609.62b913b2.png";